import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useMassFormatter } from "hooks/useMassFormatter";
import { useHoveredMaterialContext } from "contexts/HoveredMaterialContext";
import { BasketMaterial } from "./types";

interface BasketPlotLayerProps {
  material: BasketMaterial;
  height: number;
}

export const BasketPlotLayer: React.FC<BasketPlotLayerProps> = ({
  material,
  height,
}) => {
  const theme = useTheme();
  const { hoveredMaterial, setHoveredMaterial } = useHoveredMaterialContext();
  const { formatMass } = useMassFormatter();

  const isHovered = hoveredMaterial === material.name;

  return (
    <Box
      onMouseEnter={() => {
        setHoveredMaterial(material.name);
      }}
      onMouseLeave={() => {
        setHoveredMaterial(null);
      }}
      sx={{
        backgroundColor: material.color,
        border: `1px solid ${theme.palette.grey[800]}`,
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: isHovered ? `inset 0 0 0 3px white` : "none",
        transition: "box-shadow 0.2s ease-in-out",
        zIndex: isHovered ? 10 : 1,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography
          sx={{
            fontWeight: "medium",
            color: theme.palette.common.white,
            textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
            lineHeight: 1.3,
          }}
          fontSize="1.1rem"
        >
          {material.name}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: theme.palette.common.white,
            textShadow: "1px 1px 2px rgba(0,0,0,0.7)",
            fontSize: "1.1rem",
            lineHeight: 1.3,
          }}
        >
          {formatMass(material.mass)}
        </Typography>
      </Stack>
    </Box>
  );
};
